import { PageBlock, PageBlockInput, Registry } from './base'
import { Apply, CortezaID, NoID } from '../../../cast'
import { Button } from './types'
import { Compose as ComposeAPI } from '../../../api-clients'
import { Module } from '../module'

const kind = 'Chat'

interface Options {
  moduleID: string;
  filter: string;

  // Fields
  contentField: string;
  referenceField: string;
  nameField: string;
  numberField: string;
  typeField: string;
  statusField: string;
  customDateField: string;

  // Behavior
  sortDirection: string;
  refreshRate: number;
  showRefresh: boolean;

  // Magnify
  magnifyOption: string;

  // HTTP Endpoint Configuration
  httpEndpoint: string;
  httpMethod: string;

  // Send Message Workflow Button
  sendMessageButton: Array<Button>;
}

const defaults: Readonly<Options> = Object.freeze({
  moduleID: NoID,
  filter: '',
  contentField: '',
  referenceField: '',
  nameField: '',
  numberField: '',
  typeField: '',
  statusField: '',
  customDateField: '',
  sortDirection: 'asc',
  refreshRate: 0,
  showRefresh: false,
  magnifyOption: '',
  httpEndpoint: '',
  httpMethod: 'POST',
  sendMessageButton: [],
})

export class PageBlockChat extends PageBlock {
  readonly kind = kind

  options: Options = { ...defaults }

  constructor(i?: PageBlockInput) {
    super(i)
    this.applyOptions(i?.options as Partial<Options>)
  }

  applyOptions(o?: Partial<Options>): void {
    if (!o) return

    // IDs
    Apply(this.options, o, CortezaID, 'moduleID')

    // Strings
    Apply(this.options, o, String,
      'filter',
      'contentField',
      'referenceField',
      'nameField',
      'numberField',
      'typeField',
      'statusField',
      'customDateField',
      'sortDirection',
      'magnifyOption',
      'httpEndpoint',
      'httpMethod'
    )

    // Numbers
    Apply(this.options, o, Number, 'refreshRate')

    // Booleans
    Apply(this.options, o, Boolean, 'showRefresh')

    if (o.sendMessageButton !== undefined) {
      if (Array.isArray(o.sendMessageButton)) {
        this.options.sendMessageButton = o.sendMessageButton.map(b => new Button(b))
      } else {
        this.options.sendMessageButton = [new Button(o.sendMessageButton)]
      }
    }
  }

  getSendMessageWorkflowID(): string {
    return this.options.sendMessageButton.length > 0 ? (this.options.sendMessageButton[0].workflowID ?? '') : ''
  }

  getSendMessageResourceType(): string {
    return this.options.sendMessageButton.length > 0 ? (this.options.sendMessageButton[0].resourceType ?? 'compose:record') : 'compose:record'
  }
}

Registry.set(kind, PageBlockChat)